import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'dateToString',
})
export class DateToString implements PipeTransform {
	public transform(date: Date): string {
		function addZero(i): any {
			if (i < 10) {
				i = '0' + i;
			}

			return i;
		}

		return date.getFullYear().toString() + '-' + addZero(date.getMonth() + 1) + '-' + addZero(date.getDate().toString());
	}
}
